import * as React from "react";
import {Party, PaymentCard,} from "@falcon/services";
import {getAmountToDisplay} from "../../CommonFunctions";
import {PanelDashed} from "../PanelDashed";

interface IProps {
    location?: any,
    amount: number | null,
    party: Party,
    handleExistingCardPayment: (event: any, cardId?: number) => void,
    newCardUrl: string,
    mainCard?: PaymentCard
}

export class CardPaymentPanel extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <React.Fragment>
                {this.renderPaymentContent()}
            </React.Fragment>
        );
    }

    private renderCardsButtons(card?: PaymentCard): JSX.Element {
        const amountToPay = this.props.amount;

        return (
            <button className="btn btn-primary btn-make-payment m-auto margin-top-17 justify-content-center"
                onClick={(event: any) => this.props.handleExistingCardPayment(event, card?.id)}
                id={"card-" + card?.cardNumberObfuscated}
                aria-label={`${getAmountToDisplay(amountToPay)} to pay`}
            >
                {`Pay ${getAmountToDisplay(amountToPay)}`}
                <span className="payment-lock-image"></span>
            </button>
        )
    };

    private renderPaymentContent(): JSX.Element {
        return (
            <React.Fragment>
                <PanelDashed className="shadow bg-white text-center pay-by-card-panel">
                    <div className="panel-dashed-contents card-information">{this.renderCardInformation(this.props.mainCard)}</div>
                    {this.props.mainCard &&
                        <>
                            <div className="pb-2 or-divider"> OR </div>
                            <div className="simple-link no-outline use-different-cart-link"
                                 id="changeCard"
                                 role="link"
                                 aria-label="Use a different card to pay"
                                 onClick={this.navigateToNewPaymentCardPage}
                                 tabIndex={0}
                            >
                                Use a different card
                            </div>
                        </>
                    }
                    <div className="panel-dashed-contents card-buttons">{this.renderCardsButtons(this.props.mainCard)}</div>
                </PanelDashed>
            </React.Fragment>
        );
    }

    private navigateToNewPaymentCardPage = (): void => {
        window.location.href = this.props.newCardUrl;
    };

    private renderCardInformation(card?: PaymentCard): JSX.Element {
        if (card) {
            return (
                <div className="d-flex justify-content-center mt-3">
                    <div className="card-details-wrapper">
                        <span className="pr-2">{this.renderCardImage(card)}</span>&nbsp;
                        <span>{this.renderCardTypeName(card)}</span>&nbsp;
                        <span>ending in <b>{card.cardNumberObfuscated.split('******')[1]}</b></span>
                    </div>
                </div>
            );
        } else {
            return <React.Fragment/>
        }
    };

    private renderCardImage = (card: PaymentCard): JSX.Element => {
        if (card.cardType.includes("VISA")) {
            return <img className="payment-icon" alt="Visa icon" src="/img/visa-icon.svg"/>;
        }
        if (card.cardType.includes("MASTERCARD")) {
            return <img className="payment-icon" alt="Mastercard icon" src="/img/mastercard-icon.svg"/>;
        }
        return <React.Fragment/>;
    };

    private renderCardTypeName = (card: PaymentCard): string => {
        if (card.cardType.includes("VISA")) {
            return "Visa";
        }
        if (card.cardType.includes("MASTERCARD")) {
            return "Mastercard";
        }
        return "";
    };
}



// WEBPACK FOOTER //
// ./src/components/payments/CardPaymentPanel.tsx